import { MediaListResponse, MediaParams } from '@/models/media';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import { buildQueryString, prepareHeaders } from '@/state/slices';

export const MediaAPI = createApi({
  reducerPath: 'MediaAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  tagTypes: ['Media'],
  endpoints: (builder) => ({
    getMedia: builder.query<MediaListResponse, MediaParams>({
      query: (filters) => {
        const queryString = buildQueryString(
          filters as Record<string, unknown>
        );
        return {
          url: `/media/${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              { type: 'Media', id: 'LIST' },
              ...(result.results ?? []).map((media) => ({
                type: 'Media' as const,
                id: media.uuid,
              })),
            ]
          : [{ type: 'Media', id: 'LIST' }],
    }),
  }),
});

export const { useGetMediaQuery } = MediaAPI;
